

export enum ExcursionConfigurationsEmailKeys {
  excursionsGroupedDate = 'excursionsGroupedDate',
  excursionsGroup = 'excursionsGroup',
}
